import './SubmissionSuccess.scss';

import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@myome/ui';

interface SubmissionSuccessProps {
  submittedAt: Date;
  patientEmail: string;
  filename: string;
  onSubmitAnother: () => void;
}

const formatTimestamp = (date: Date): string =>
  date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

export const SubmissionSuccess = ({ submittedAt, patientEmail, filename, onSubmitAnother }: SubmissionSuccessProps) => {
  return (
    <div className='submission-success'>
      <div className='submission-success__badge' role='status' aria-live='polite'>
        <FontAwesomeIcon icon={faCheck} className='me-2' aria-hidden='true' />
        Submission received
      </div>
      <h1 className='submission-success__heading'>Thanks! Your referral is in our review queue.</h1>
      <p className='submission-success__body'>
        Our curation team will review this submission internally. If eligible, we contact the patient directly;
        you&apos;ll only hear from us if there&apos;s a question or after the case is resolved.
      </p>

      <dl className='submission-success__meta'>
        <div className='submission-success__meta-item'>
          <dt>Submitted</dt>
          <dd>{formatTimestamp(submittedAt)}</dd>
        </div>
        <div className='submission-success__meta-item'>
          <dt>Patient email</dt>
          <dd data-openreplay-sanitize>{patientEmail}</dd>
        </div>
        <div className='submission-success__meta-item'>
          <dt>Report</dt>
          {/* Filenames frequently contain PHI ("JohnSmith_Genomic_Report.pdf"); mask in session replay. */}
          <dd data-openreplay-sanitize>{filename}</dd>
        </div>
      </dl>

      <div className='submission-success__next'>
        <div className='submission-success__next-label'>What happens next</div>
        <ol className='submission-success__next-list'>
          <li>Internal eligibility + variant review (3-5 business days).</li>
          <li>If eligible, we email the patient an invitation. They opt in on their own.</li>
          <li>If we need anything from you, we&apos;ll reach out using the contact info above.</li>
        </ol>
      </div>

      <div className='submission-success__actions'>
        <Button variant='secondary' onClick={onSubmitAnother} type='button' dataTestId='submit-another-referral'>
          Submit another referral
        </Button>
      </div>
    </div>
  );
};
